import React from "react";
import "./SellInIndiaForm.css";

export default function SellInIndiaForm() {
  return (
    <div className="sell-in-india-container">
      <header className="sell-in-india-header">
        <h2>🚀 Start Selling in India</h2>
        <p>
          Join the fastest way to test and grow your product in the Indian market
        </p>
        <span>
          We handle everything: fulfillment, packaging, warehousing, returns,
          payments, and taxation.
        </span>
      </header>

      {/* Company & Contact Details */}
      <section className="sell-in-india-form-section">
        <h3>📇 Company & Contact Details</h3>
        <div className="sell-in-india-form-grid">
          <input placeholder="Company Name" />
          <input placeholder="Country of Headquarters" />

          <input placeholder="Business Website" />
          <input placeholder="Full Name of Founder / Key Decision Maker" />

          <input placeholder="Email Address" />
          <input placeholder="Phone Number (with Country Code)" />

          <select>
            <option>Email</option>
            <option>Phone</option>
            <option>WhatsApp</option>
          </select>
        </div>
      </section>

      {/* Product Details */}
      <section className="sell-in-india-form-section">
        <h3>📦 Product Details</h3>
        <div className="sell-in-india-form-grid">
          <input placeholder="Product Name(s)" />
          <select>
            <option>Health</option>
            <option>Beauty</option>
            <option>Electronics</option>
          </select>

          <input placeholder="Total Number of SKUs" />
          <input placeholder="Average Price per unit (USD)" />

          <input placeholder="Target Customer" />
          <input placeholder="Product Dimensions & Weight" />
          <input placeholder="Shelf Life" />

          <label>
            Is the product export-ready?{" "}
            <span>
              <input type="radio" name="export" /> Yes
              <input type="radio" name="export" /> No
            </span>
          </label>
        </div>
      </section>

      {/* Sales & Market Information */}
      <section className="sell-in-india-form-section">
        <h3>📊 Sales & Market Information</h3>
        <div className="sell-in-india-form-grid">
          <input placeholder="Current Annual Revenue (USD)" />
          <input placeholder="Top-performing product" />
          <textarea placeholder="Markets you're currently selling in"></textarea>

          <label>
            Are you already selling in India?{" "}
            <span>
              <input type="radio" name="sellingIndia" /> Yes
              <input type="radio" name="sellingIndia" /> No
            </span>
          </label>

          <textarea placeholder="Why do you want to enter the Indian market now?"></textarea>
        </div>
      </section>

      {/* Fulfillment & Marketing Preferences */}
      <section className="sell-in-india-form-section">
        <h3>⚙ Fulfillment & Marketing Preferences</h3>
        <div className="sell-in-india-form-grid">
          <label>
            Do you need help with branding/packaging localization?
            <span>
              <input type="radio" name="branding" /> Yes
              <input type="radio" name="branding" /> No
            </span>
          </label>

          <label>
            Do you already have a marketing team/agency?
            <span>
              <input type="radio" name="marketing" /> Yes
              <input type="radio" name="marketing" /> No
            </span>
          </label>

          <label>
            Are you open to launching on Amazon, Flipkart, etc.?
            <span>
              <input type="radio" name="amazon" /> Yes
              <input type="radio" name="amazon" /> No
            </span>
          </label>

          <label>
            Would you consider franchise/retail expansion in the future?
            <span>
              <input type="radio" name="franchise" /> Yes
              <input type="radio" name="franchise" /> No
            </span>
          </label>
        </div>
      </section>

      {/* Legal & Compliance */}
      <section className="sell-in-india-form-section">
        <h3>⚖ Legal & Compliance</h3>
        <div className="sell-in-india-form-grid">
          <label>
            Do you have an Importer of Record (IOR) for India?
            <span>
              <input type="radio" name="ior" /> Yes
              <input type="radio" name="ior" /> No
            </span>
          </label>

          <label>
            Do you have an IEC Import Export Code?
            <span>
              <input type="radio" name="iec" /> Yes
              <input type="radio" name="iec" /> No
              <input type="radio" name="iec" /> Need Help
            </span>
          </label>

          <label>
            Do you require help with Indian regulatory compliance?
            <span>
              <input type="radio" name="compliance" /> Yes
              <input type="radio" name="compliance" /> No
              <input type="radio" name="compliance" /> Not Sure
            </span>
          </label>
        </div>
      </section>

      {/* Basic Plan */}
      <section className="sell-in-india-basic-plan">
        <h3>💡 Basic Plan Confirmation</h3>
        <p>6 Months Trial at $0</p>
        <p>$49/month after trial (cancel anytime)</p>
        <small>
          Upgrade to our Guaranteed Sales Plan only after we review your
          product's potential.
        </small>
        <p className="sell-in-india-notice">
          By submitting this form, you agree to our terms of service and
          understand that your 6-month free trial will start upon onboarding
          confirmation.
        </p>
      </section>

      {/* Uploads */}
      <section className="sell-in-india-form-section">
        <h3>📤 Final Step: Uploads</h3>
        <div className="sell-in-india-upload-box">
          <p>Upload Product Brochure / Pitch Deck</p>
          <input type="file" />
        </div>
        <div className="sell-in-india-upload-box">
          <p>Upload High-Quality Product Photos</p>
          <input type="file" multiple />
        </div>
      </section>

      <button className="sell-in-india-submit-btn">Submit</button>
    </div>
  );
}
